import { render, staticRenderFns } from "./DialogTikTokFollowCheck.vue?vue&type=template&id=5db97bfc&scoped=true"
import script from "./DialogTikTokFollowCheck.vue?vue&type=script&lang=ts"
export * from "./DialogTikTokFollowCheck.vue?vue&type=script&lang=ts"
import style0 from "./DialogTikTokFollowCheck.vue?vue&type=style&index=0&id=5db97bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db97bfc",
  null
  
)

export default component.exports